export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/a2cdf02300b2663230f496dbfe02b4a0.svg";